import * as React from 'react';
const SvgCopywriting = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M92.827 58.792c3.745-5.763 5.947-12.63 5.947-20.018C98.774 18.466 82.308 2 62 2S25.226 18.466 25.226 38.774 41.692 75.548 62 75.548c7.388 0 14.25-2.201 20.017-5.942l16.757 5.942-5.947-16.756Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.247 85.27c-4.263 15.59-18.532 27.053-35.473 27.053-7.389 0-14.25-2.202-20.018-5.942L2 112.323l5.947-16.762C4.202 89.798 2 82.937 2 75.548c0-10.834 4.689-20.574 12.14-27.305M25.313 41.348c3.958-1.451 9-2.574 13.461-2.574 19.166 0 34.921 14.115 36.615 34.244"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.226 48.452c-6.184 0-12.465 1.62-17.579 4.32M64.55 115.637A36.59 36.59 0 0 0 85.226 122c7.664 0 14.25-2.202 20.017-5.942L122 122l-5.947-16.761C119.798 99.476 122 92.615 122 85.226c0-16.065-10.442-29.918-25.074-34.945M58.57 59.89c-6.272 6.6-10.118 15.523-10.118 25.336 0 8.197 2.864 16.369 7.814 22.674"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCopywriting;
